'use strict';

module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};



//////////////////
// WEBPACK FOOTER
// ./~/.0.15.3@axios/lib/cancel/isCancel.js
// module id = 27
// module chunks = 1